import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';

@IonicPage()
@Component({
  selector: 'page-users',
  templateUrl: 'users.html',
})
export class UsersPage {

  formModal: any = {
    id: null,
    nome: "",
    email: "",
    login: "",
    senha: "",
    rsenha: ""
  }
  form: any = {
    status: "",
    search: "",
    page: 1,
    forpage: 10
  }
  resultData: any = null;
  urlSearch = "/usuarios";


  constructor(public navCtrl: NavController, public navParams: NavParams,
    private msgHelper: MessageHelper, private service: ServiceProvider,
    private alertCtrl: AlertController) {

  }

  ionViewWillEnter() {
    this.search();
  }

  public new() {
    this.formModal = {
      id: null,
      nome: "",
      email: "",
      login: "",
      senha: "",
      rsenha: ""
    };
    document.getElementById("modal-new-user").classList.add("show");
  }

  public update(user: any) {
    this.formModal.id = user.id;
    this.formModal.nome = user.nome;
    this.formModal.email = user.email;
    this.formModal.login = user.login;
    this.formModal.senha = "";
    this.formModal.rsenha = "";
    document.getElementById("modal-new-user").classList.add("show");
  }

  /**
   * Salva os dados usuário
   * @returns void
   */
  public saveUser() {
    if (this.formModal.nome == "") {
      return this.msgHelper.showToast("Você precisa informar o nome completo", "bottom", 1500);
    }
    if (this.formModal.email == "") {
      return this.msgHelper.showToast("Você precisa informar o email", "bottom", 1500);
    }
    if (this.formModal.login == "") {
      return this.msgHelper.showToast("Você precisa informar o login", "bottom", 1500);
    }
    if (this.formModal.senha != "" && this.formModal.rsenha == "") {
      return this.msgHelper.showToast("Você precisa confirmar a senha", "bottom", 1500);
    }

    this.msgHelper.createLoading('crescent', 'Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.formModal, "/usuarios/save", false).then(result => {
      this.msgHelper.closeLoading();
      let response: any = result;
      if (response.result == 0) {
        return this.msgHelper.showAlert("Atenção!", response.message);
      }
      this.msgHelper.showAlert("Sucesso!", response.message);
      document.getElementById("modal-new-user").classList.remove("show");
      this.search();
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps", error.message);
    });

  }

  /**
   * Remove o usuário do sistema
   * @param user any
   */
  public delete(user: any) {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja mesmo remover o usuário?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({token: user.token}, "/usuarios/delete", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Bloquear o usuário
   * @param user any
   */
  public block(user : any)
  {
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja bloquear o acesso do usuário?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({token: user.token}, "/usuarios/block", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

  /**
   * Ativar o usuário
   * @param user any
   */
   public active(user : any)
   {
     let alert = this.alertCtrl.create({
       title: 'Atenção',
       message: 'Você deseja ativar o acesso do usuário?',
       buttons: [
         {
           text: 'Não',
           role: 'cancel',
           handler: () => {
           }
         },
         {
           text: 'Sim',
           handler: () => {
             this.msgHelper.createLoading('crescent', 'Carregando...');
             this.msgHelper.showLoading();
 
             this.service.postData({token: user.token}, "/usuarios/active", false).then(result => {
               this.msgHelper.closeLoading();
               let response: any = result;
               if (response.result == 0) {
                 return this.msgHelper.showAlert("Atenção!", response.message);
               }
               this.msgHelper.showAlert("Sucesso!", response.message);
               this.search();
             }, error => {
               this.msgHelper.closeLoading();
               this.msgHelper.showAlert("Opps", error.message);
             });
           }
         }
       ]
     });
     alert.present();
   }

  public search() {
    this.form.page = 1;
    this.getData();
  }

  public backAll()
  {
    this.search();
  }

  public backPage()
  {
    this.form.page = this.form.page - 1;
    this.getData();
  }

  public nextPage()
  {
    this.form.page = this.form.page + 1;
    this.getData();
  }

  public nextAll(){
    this.form.page = this.resultData.totalPages;
    this.getData();
  }

  /**
   * Retorna os dados da API
   */
  private getData() {
    this.resultData = null;
    this.service.postData(this.form, this.urlSearch, false).then(result => {
      this.resultData = result;
      if (this.resultData.result == 0) {
        this.resultData = null;
      } else {
        this.resultData = this.resultData.data;
      }
      console.log(this.resultData);
    }, error => {
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/users/users.ts